import {
    takeLatest,
    put,
    call,
    fork
    // all
} from "redux-saga/effects";
import { DocumentsService } from "services";

import {
    fetchedDocumentsChecklist,
    failedFetchDocumentsChecklist,
    fetchedCaseDocuments,
    failedFetchCaseDocuments,
    fetchedCompanyDocuments,
    failedFetchCompanyDocuments,
    uploadedDocument,
    failedUploadDocument,
    attachedDocument,
    failedAttachDocument,
    updatedDocument,
    failedUpdateDocument,
    validatedDocument,
    validatedDocumentApproval,
    failedValidateDocument,
    invalidatedDocument,
    invalidatedDocumentStatus,
    failedInvalidateDocument,
    fetchCompanyDocuments,
    fetchedDocumentTypes,
    failedFetchDocumentTypes,
    fetchedApplicantsList,
    failedFetchApplicantsList,
    requestedDocuments,
    failedRequestDocuments,
    parsedDocument,
    failedParseDocument,
    notificationSent,
    failedToSendNotification,
    updateCompanySingleAssociate,
    updateCompanyMultipleAssociate,
    attachDocument,
    addedRequestRemarks,
    failedAddRequestRemarks,
    updateCompanySingleBankAccount,
    fetchedDocumentsCaseV2,
    failedFetchDocumentsCaseV2,
} from "store/actions";

import { DOCUMENTS_ACTIONS, DOCUMENT_REVIEW_ACTIONS } from "constants/actions";
import { message } from "antd";
import { fetchCaseDetail } from "../actions";
// import // STATE_STATUS
// "constants/index";

function* fetchDocumentsChecklist({ payload: { case_id, type } }) {
    try {
        const { data, error } = yield call(
            DocumentsService.getDocumentChecklist,
            case_id,
            type
        );
        if (!error) {
            yield put(fetchedDocumentsChecklist(case_id, type, data));
        } else {
            yield put(failedFetchDocumentsChecklist(case_id, type, error));
        }
    } catch (e) {
        if (e.response.status >= 500) {
            message.error("Failed to Fetch Document Checklist", 2);
        }
        else {
            message.error("Failed to Fetch Document Checklist", 2);
        }
        yield put(failedFetchDocumentsChecklist(case_id, type, e));
    }
}

function* fetchCompanyDocumentHandler({ payload: { case_id, company_id } }) {
    try {
        const { data, error } = yield call(
            DocumentsService.getCompanyDocuments,
            company_id
        );
        if (!error) {
            yield put(fetchedCompanyDocuments(case_id, company_id, data));
        } else {
            yield put(failedFetchCompanyDocuments(case_id, company_id, error));
        }
    } catch (error) {
        yield put(failedFetchCompanyDocuments(case_id, company_id, error));
    }
}
function* fetchDocumentCaseV2Handler({ payload: { case_id, company_id} }) {
    try {
        const { data, error } = yield call(
            DocumentsService.getCaseV2Documents,
            company_id,
            case_id
        );    
        if (!error) {
            yield put(fetchedDocumentsCaseV2(case_id, company_id, data));
        } else {
            yield put(failedFetchDocumentsCaseV2(case_id, company_id, error));
        }
    } catch (error) {
        yield put(failedFetchDocumentsCaseV2(case_id, company_id, error));
    }
}

function* fetchCaseDocuments({ payload: { case_id  , kycDocAssociate} }) {
    try {
        const { data, error } = yield call(
            DocumentsService.getCaseDocuments,
            case_id,
            kycDocAssociate
        );
        if (!error) {
            yield put(fetchedCaseDocuments(case_id, data));
        } else {
            yield put(failedFetchCaseDocuments(case_id, error));
        }
    } catch (error) {
        message.error("Something went wrong. Please Try Again");
        yield put(failedFetchCaseDocuments(case_id, error));
    }
}

function* fetchDocumentMasterList({payload  : {companyId}}) {

    try {
        const { data, error } = yield call(DocumentsService.fetchDocumentMasterList , companyId);
        if (!error) {
            yield put(fetchedDocumentTypes(data , companyId));
        } else {
            yield put(failedFetchDocumentTypes(error));
        }
    } catch (error) {
        yield put(failedFetchDocumentTypes(error));
    }
}

function* requestDocumentHandler({ payload: { caseId, companyId, docs, postDocs } }) {
    try {
        const { data, error } = postDocs ?
            yield call(DocumentsService.requestPostSanctionDocuments, companyId, docs , caseId) :
            yield call(DocumentsService.requestDocuments, companyId, docs , caseId);
        if (!error) {
            yield put(requestedDocuments(caseId, data));
            yield put(fetchCompanyDocuments(caseId, companyId));
            message.success("Documents Requested");
        } else {
            yield put(failedRequestDocuments(caseId, error));
            message.error("Failed to Request Documents");
        }
    } catch (error) {
        yield put(failedRequestDocuments(caseId, error));
        message.error("Failed to Request Documents");
    }
}

function* fetchCompanyAssociatesList({ payload: { companyId } }) {
    try {
        const { data, error } = yield call(DocumentsService.getAssociatesList, companyId);
        if (!error) {
            yield put(fetchedApplicantsList(companyId, data));
        } else {
            yield put(failedFetchApplicantsList(companyId, error));
        }
    } catch (error) {
        yield put(failedFetchApplicantsList(companyId, error));
    }
}

function* sendNotification({ payload: { caseId } }) {
    try {
        const { error } = yield call(DocumentsService.sendDocumentNotification, caseId);
        if (!error) {
            message.success("Notification Sent");
            yield put(notificationSent());
        } else {
            message.error("Failed to sent Notification");
            yield put(failedToSendNotification());
        }
    } catch (error) {
        message.error("Failed to sent Notification");
        yield put(failedToSendNotification);
    }
}

function* uploadDocument({ payload: { case_id, company_id, document } }) {
    try {
        message.loading("Uploading new Document");
        const { data, error } = yield call(
            DocumentsService.uploadDocuments,
            document
        );
        if (!error) {
            yield put(uploadedDocument(case_id, company_id, data));
            message.success("Document Uploaded");
        } else {
            yield put(failedUploadDocument(case_id, company_id, error));
            message.error("Failed to create new document");
        }
    } catch (error) {
        yield put(failedUploadDocument(case_id, company_id, error));
        message.error("Failed to create new document");
    }
}

// function* uploadDocuments({ payload: { case_id, company_id, documents } }) {
//     const values = yield all(
//         new List(documents)
//             .map(_ => {
//                 const formData = new FormData();
//                 formData.append("file", _);
//                 formData.append("file_name", _.name);
//                 formData.append("company", company_id);
//                 return {
//                     uid: _.uid,
//                     response: call(DocumentsService.uploadDocuments, formData)
//                 };
//             })
//             .toArray()
//     );
//     yield put(
//         uploadedDocuments(
//             case_id,
//             company_id,
//             new List(values).toMap().mapEntries(([, v]) => [
//                 v.uid,
//                 {
//                     status: !v.response.error
//                         ? STATE_STATUS.UPLOADED
//                         : STATE_STATUS.UPLOAD_FAILED
//                 }
//             ])
//         )
//     );
//     if (values.reduce((agg, _) => agg && !_.response.error, true)) {
//         yield* fetchCompanyDocuments({
//             payload: {
//                 case_id,
//                 company_id
//             }
//         });
//     }
//     // if (!window.error) {
//     //     yield put(uploadedDocuments(case_id, window.data));
//     // } else {
//     //     yield put(failedUploadDocuments(case_id, window.error));
//     // }
// }

function* attachDocumentHandler({ payload: { type, case_id, doc ,validateFromCompany, refresh_page} }) {
    try {
        
        const { data, error } = !validateFromCompany ? yield call(DocumentsService.attachDocument, doc) : yield call(DocumentsService.attachCompanyDocument, doc);
        if (!error) {
            if(case_id && refresh_page){
                yield put(fetchCaseDetail(case_id));
            }
            yield put(attachedDocument(type, case_id, data));
        } else {
            yield put(failedAttachDocument(type, case_id, error));
            message.error("Failed to Attach Document");
        }
    } catch (error) {
        yield put(failedAttachDocument(type, case_id, error));
    }
}

function* updateDocument({ payload: { case_id, company_id, docId, doc } }) {
    try {
        const { error } = yield call(
            DocumentsService.updateDocument,
            doc
        );
        if (!error) {
            yield put(updatedDocument(case_id, company_id, docId));
        } else {
            yield put(failedUpdateDocument(case_id, company_id, docId));
        }
    } catch (error) {
        yield put(failedUpdateDocument(case_id, company_id, docId));
    }
}

function* validateDocumentHandler({ payload: { company_id, case_id, file, associate, address, bankAccount  , validateFromCompany} }) {
    try {
        message.loading("Updating Document", 2);
        const { error } = yield call(
            DocumentsService.validateDocument,
            company_id,
            file.id,
            {...file.validatedValues , case_id}
        );

        if (!error) {
            yield put(validatedDocument(company_id, case_id, file));
            yield put(validatedDocumentApproval());
            if (bankAccount) {
                yield put(updateCompanySingleBankAccount(company_id, bankAccount));
            }
            if (associate) {
                if (Array.isArray(associate)) {
                    const associates = associate.map((assoc) => {
                        return {
                            company: assoc.company,
                            id: assoc.id,
                            name_gst: assoc.name_gst
                        };
                    });
                    yield put(updateCompanyMultipleAssociate(associates, company_id));
                } else {
                    yield put(updateCompanySingleAssociate(associate, address, file, company_id, case_id , {validateFromCompany: validateFromCompany}));
                }
            }
            else if (case_id) {
                yield put(attachDocument(file.document && file.document.id, case_id, {
                    case: case_id,
                    company: company_id,
                    file: file.id,
                    document: file.document && file.document.id,
                    is_valid: true
                }));
            }
            if(company_id){
                yield put(fetchCompanyDocuments('',company_id))
            }
            message.info("Updated Document", 2);
            return;
        }
        message.info("Failed Approve Document", 2);
        yield put(failedValidateDocument(company_id, case_id, file));
    } catch (error) {

        message.info("Failed Approve Document", 2);
        yield failedValidateDocument(company_id, case_id, file, error);
    }
}

function* invalidateDocumentHandler({ payload: { company_id, case_id, file } }) {
    try {
        message.loading("Invalidating Document", 2);
        const { error } = yield call(
            DocumentsService.validateDocument,
            company_id,
            file.id,
            file.validatedValues
        );

        if (!error) {
            yield put(invalidatedDocument(company_id, case_id, file));
            yield put(invalidatedDocumentStatus());
            message.info("Invalidated Document", 2);
            return;
        }
        message.info("Failed Invalidate Document", 2);
        yield put(failedInvalidateDocument(company_id, case_id, file));
    } catch (error) {

        message.info("Failed Invalidate Document", 2);
        yield failedValidateDocument(company_id, case_id, file, error);
    }
}

function* addRequestDocumentRemarks({ payload: { company_id, case_id, file } }) {
    try {
        message.loading("Updating Remarks for requested document", 2);
        let payload = {};
        if(!file.validatedValues){
            payload= {
                file_name: file.file_name,
                id: file.id,
                document: file.document? file.document.id :null,
                document_status: file.document_status,
                is_active: file.is_active,
                remarks: file.remarks,
                parse_data: file.parse_data,
                request_remarks: file.request_remarks
            }
        }
        const { error } = yield call(
            DocumentsService.validateDocument,
            company_id,
            file.id,
            file.validatedValues || payload
        );

        if (!error) {
            yield put(addedRequestRemarks(company_id, case_id, file));
            message.info("Remarks Updated for document", 2);
            return;
        }
        message.info("Failed to Update Remarks", 2);
        yield put(failedAddRequestRemarks(company_id, case_id, file));
    } catch (error) {

        message.info("Failed to update Remarks", 2);
        yield failedAddRequestRemarks(company_id, case_id, file, error);
    }
}

// function* invalidateDocumentHandler({ payload: { company_id, document_id, inValidatedData, case_id, fileObj } }) {
//     try {
//         const { data, error } = yield call(
//             DocumentsService.inValidateDocument,
//             company_id,
//             document_id,
//             inValidatedData
//         );
//         if (!error) {
//             yield put(invalidatedDocument(company_id, document_id, data));
//             if(fileObj) {
//                 yield put(attachDocument(fileObj.document, fileObj.caseId, fileObj.file));
//             }
//             yield put(fetchCompanyDocuments(case_id, company_id));
//         } else {
//             yield put(failedInvalidateDocument(company_id, document_id, error));
//         }
//     } catch(error) {
//         yield put(failedInvalidateDocument(company_id, document_id, error));
//     }
// }

function* parseDocument({ payload: { documentType, document } }) {
    try {
        message.loading("Parsing Data", 2);
        const { data, error } = yield call(
            DocumentsService.parseDocWithSignzy,
            documentType,
            document.file
        );
        if (!error) {
            if (data.code === 400) {
                message.error("Failed to Parse Data on this Document");
            }
            if (document.type) {
                yield put(parsedDocument({...data.data ,document}));

            } else {
                yield put(parsedDocument((document.mergeIn(["parse_data"], data.data))));
            }
        } else {
            yield put(failedParseDocument(document, error));
            message.error("Failed to fetch data from signzy");
        }
    } catch (error) {
        yield put(failedParseDocument(document, error));
        message.error("Failed to fetch data from signzy");
    }
}

export default fork(function* () {
    yield takeLatest(
        DOCUMENTS_ACTIONS.FETCH_DOCUMENTS_CHECKLIST,
        fetchDocumentsChecklist
    );
    yield takeLatest(
        DOCUMENTS_ACTIONS.FETCH_CASE_DOCUMENTS,
        fetchCaseDocuments
    );
    yield takeLatest(
        DOCUMENTS_ACTIONS.FETCH_COMPANY_DOCUMENTS,
        fetchCompanyDocumentHandler
    );
    yield takeLatest(DOCUMENTS_ACTIONS.UPLOAD_DOCUMENT, uploadDocument);
    yield takeLatest(DOCUMENTS_ACTIONS.ATTACH_DOCUMENTS, attachDocumentHandler);
    yield takeLatest(DOCUMENTS_ACTIONS.UPDATE_DOCUMENTS, updateDocument);
    yield takeLatest(DOCUMENTS_ACTIONS.VALIDATE_DOCUMENT, validateDocumentHandler);
    yield takeLatest(DOCUMENTS_ACTIONS.INVALIDATE_DOCUMENT, invalidateDocumentHandler);
    yield takeLatest(DOCUMENT_REVIEW_ACTIONS.FETCH_APPLICANTS_LIST, fetchCompanyAssociatesList);
    yield takeLatest(DOCUMENT_REVIEW_ACTIONS.FETCH_DOCUMENT_TYPES, fetchDocumentMasterList);
    yield takeLatest(DOCUMENT_REVIEW_ACTIONS.REQUEST_DOCUMENTS, requestDocumentHandler);
    yield takeLatest(DOCUMENT_REVIEW_ACTIONS.PARSE_DATA, parseDocument);
    yield takeLatest(DOCUMENT_REVIEW_ACTIONS.SEND_NOTIFICATION, sendNotification);
    yield takeLatest(DOCUMENT_REVIEW_ACTIONS.ADD_REQUEST_REMARKS, addRequestDocumentRemarks);
    yield takeLatest(DOCUMENTS_ACTIONS.FETCH_DOCUMENTS_CASE_V2,fetchDocumentCaseV2Handler)
});
